import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, InputSignal, output, signal } from '@angular/core';
import { DateFieldComponent, TimeFieldsComponent, MovilityFieldComponent, LocationFieldComponent, TripTypesFieldComponent, InterestsFieldComponent, TransportMeansFieldComponent, MaxDistanceFieldComponent } from "../../shared/components";
import { TranslateModule } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { RegisterUserFormDesktopService } from './services';
import { RegisterUserService } from '../../services';


@Component({
  selector: 'app-register-user-form-desktop',
  standalone: true,
  imports: [
    TranslateModule,
    DateFieldComponent,
    TimeFieldsComponent,
    MovilityFieldComponent,
    LocationFieldComponent,
    TripTypesFieldComponent,
    InterestsFieldComponent,
    TransportMeansFieldComponent,
    MaxDistanceFieldComponent,
    MatTooltip
],
  templateUrl: './register-user-form-desktop.component.html',
  styleUrls: ['./register-user-form-desktop.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterUserFormDesktopComponent {
  // INPUTS SIGNALS
  public form: InputSignal<FormGroup> = input.required<FormGroup>();

  // OUTPUT SIGNALS
  public submitFormEmitter = output<void>();

  // INJECTED SERVICES
  private _registerUserService = inject(RegisterUserService);
  private _registerUserFormDesktopService = inject(RegisterUserFormDesktopService);

  // SERVICE STATE SIGNALS
  private _shouldSubmitForm = this._registerUserFormDesktopService.shouldSubmitForm;
  protected cityLocation = this._registerUserService.cityLocation;

  // LOCAL STATE SIGNALS
  private _isFormValid = signal(false);
  
  // EFFECTS
  /**
   * Effect to emit the submit form event when the service indicates to do
   */
  submitEffect = effect(() => {    
    if (this._shouldSubmitForm()) {
      this.submitFormEmitter.emit();
    }
    this._registerUserFormDesktopService.setShouldSubmitForm(false);
  }, { allowSignalWrites: true });
  
  /**
   * Effect to track the form validity and update the local signal
   */
  trackFormValidityEffect = effect(() => {
    const formInstance = this.form();
    if (!formInstance) return;

    // Subscribe once to statusChanges
    formInstance.statusChanges.subscribe(() => {
      this._isFormValid.set(formInstance.valid);
    });
    // Set initial value
    this._isFormValid.set(formInstance.valid);
  } , { allowSignalWrites: true });
  
  /**
   * Effect to close the error snackbar when the form becomes valid
   */
  closeErrorSnackbarEffect = effect(() => {
    if (this._isFormValid()) {
      this._registerUserFormDesktopService.closeErrorFormSnackbar();
    }
  }, { allowSignalWrites: true });

  // METHODS
  /**
   * Returns the tooltip text for the submit button
   * @returns Tooltip string for the submit button
   */
  public tooltipText(): string {
    return this._registerUserFormDesktopService.getTooltipText(this.form());
  }

  /**
   * Handles the form submission logic
   * Delegates to the service, which triggers the submit signal
   */
  public handleSubmit(): void {
    this._registerUserFormDesktopService.handleSubmit(this.form());
  }
}

